import styled from "styled-components";

export const BRAND_LOGO_SRC = "/img/logo.png";

type BrandLogoProps = {
  size?: number;
  className?: string;
};

const BrandLogo = ({ size = 40, className }: BrandLogoProps) => (
  <LogoImg
    src={BRAND_LOGO_SRC}
    alt=""
    width={size}
    height={size}
    className={className}
    decoding="async"
  />
);

export default BrandLogo;

const LogoImg = styled.img`
  display: block;
  flex-shrink: 0;
  object-fit: contain;
`;
